import { Injectable } from '@angular/core';
import { Observable, forkJoin } from 'rxjs';
import { environment } from 'mapfre-auditweb/src/environments/environment';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';
import { map, mergeMap } from "rxjs/operators";
import { FileService, CacheService } from 'mapfre-auditlib';

@Injectable({
  providedIn: 'root'
})
export class ActivityService {

  className = 'ActivityService';

  constructor(private http: HttpClient, private fileService: FileService, private cacheService: CacheService) {
  }

  /*
  * Activities Type
  */

  getAllActivitiesTypes(cache = true, cacheKey = "allActivitiesTypes"): Observable<any[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      let observable = this.http.get<any[]>(environment.base_URL + "/activity-types").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  newActivity(activity) {
    return this.http.post(environment.base_URL + "/activity-types", activity)
  }

  newActivityPai(activity): Observable<any[]> {
    return this.http.post<any[]>(environment.base_URL + "/activities", activity)
  }

  addActivityWithFiles(activity): Observable<any[]> {
    // PRE FILES INI
    let filesToUpload = _.remove(_.get(activity, 'fileNames'), (f) => f instanceof File);
    // PRE FILES END
    //CHECK IF THERE ARE NEW FILES
    if (!_.isEmpty(filesToUpload)) {
      return this.newActivityPai(activity).pipe(mergeMap((res: any) => {
        let observables = _.map(filesToUpload, (f) => this.fileService.upload(f, 'activity', res));
        return forkJoin(observables).pipe(map(resultFiles => {
          return res;
        }));
      }))
    }
    else {
      return this.newActivityPai(activity)
    }
  }

  addActivityListWithFiles(activities): Observable<any[]> {
    let observables: Observable<any[]>[] = _.map(activities, (activity) => this.addActivityWithFiles(activity));
    return forkJoin(observables);
  }

  updateActivityPai(activity, id) {
    return this.http.put(environment.base_URL + `/activities/${id}`, activity)
  }

  deleteActivityPai(id) {
    return this.http.delete(environment.base_URL + `/activities/${id}`)
  }

  updateActivity(activity, id) {
    return this.http.put(environment.base_URL + `/activity-types/${id}`, activity)
  }


  getAllActivitiesByPai(id): Observable<any[]> {
    let params: any = {};
    params.paiId = id;
    return this.http.get<any[]>(environment.base_URL + "/activities", { params })
  }

  //!NO se usa
  getAllActivities(): Observable<any[]> {
    return this.http.get<any[]>(environment.base_URL + "/activities")
  }

  getActivity(id): Observable<any[]> {
    let params = {
      idActivityPk: id
    }
    return this.http.get<any[]>(environment.base_URL + "/activities", { params });
  }

}
